import { booleanAttribute, Component, input, output, signal, viewChild } from "@angular/core";
import { FormsModule, NgForm, ReactiveFormsModule } from "@angular/forms";
import { VdsButtonComponent } from "@dcc/vestas-design-system/angular/components/button";
import { VdsCheckbox } from "@dcc/vestas-design-system/angular/components/checkbox";
import { VdsErrorComponent } from "@dcc/vestas-design-system/angular/components/form-field";
import { VdsIconComponent } from "@dcc/vestas-design-system/angular/components/icon";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
    selector: "vo-shell-tos-form",
    templateUrl: "./tos-form.component.html",
    host: {
        class: "contents"
    },
    imports: [ReactiveFormsModule, VdsButtonComponent, VdsCheckbox, TranslocoDirective, FormsModule, VdsErrorComponent, VdsIconComponent]
})
export class TosFormComponent {
    private form = viewChild(NgForm);

    public submitted = signal<boolean>(false);

    public disabled = input(true, { transform: booleanAttribute });

    public updating = input<boolean>(false);

    public termsAccepted = output<void>();

    public submit(): void {
        if (this.form()?.valid && !this.submitted()) {
            this.submitted.set(true);
            this.termsAccepted.emit();
        }
    }
}
